export * from './ionic-storage.module';
